<template>
  <div class="instagram-embed-wrapper my-4" v-if="url">
    <div ref="embedContainer" class="instagram-container">
      <blockquote
        class="instagram-media"
        data-instgrm-captioned
        :data-instgrm-permalink="url"
        data-instgrm-version="14"
        style="background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"
      >
        <div style="padding:16px;">
          <a
            :href="url"
            style="background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;"
            target="_blank"
          >
            <v-skeleton-loader type="article" class="bg-transparent"></v-skeleton-loader>
          </a>
        </div>
      </blockquote>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, nextTick } from 'vue';

const props = defineProps<{
  url: string;
}>();

const embedContainer = ref<HTMLElement | null>(null);

const loadInstagramScript = () => {
  return new Promise<void>((resolve) => {
    if ((window as any).instgrm) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    document.head.appendChild(script);
  });
};

const processEmbed = async () => {
  await loadInstagramScript();
  if ((window as any).instgrm && (window as any).instgrm.Embeds) {
    (window as any).instgrm.Embeds.process();
  }
};

onMounted(() => {
  processEmbed();
});

watch(() => props.url, async () => {
  await nextTick();
  processEmbed();
});
</script>

<script lang="ts">
export const extractInstagramLinks = (text: string) => {
  if (!text) return [];
  const results: string[] = [];
  const instagramRegex = /https?:\/\/(www\.)?instagram\.com\/(p|reels|reel)\/[^\/\s\?#]+/g;
  let match;
  while ((match = instagramRegex.exec(text)) !== null) {
      results.push(match[0]);
  }
  return [...new Set(results)];
};
</script>

<style scoped>
.instagram-embed-wrapper {
  max-width: 550px;
  width: 100%;
  overflow: hidden;
  border-radius: 12px;
}

.instagram-container {
  width: 100%;
  min-height: 200px;
  display: flex;
  justify-content: center;
}

:deep(.instagram-media) {
  margin: 0 !important;
  width: 100% !important;
  border-radius: 12px !important;
}
</style>
